<template>
  <v-container>
    <v-card>
      <v-row dense>
        <v-col>
          <v-card-title>
            Feature Usage
          </v-card-title>
          <v-card-subtitle>
            See what features your company is actively using
          </v-card-subtitle>
        </v-col>
        <v-spacer class="limited-spacer"></v-spacer>
        <v-col
          class="my-auto"
          :cols="$vuetify.breakpoint.smAndDown ? '12' : 'auto'"
        >
          <v-card-text>
            <timeframe-select
              v-model="filter"
              v-on:change="getData"
            ></timeframe-select>
          </v-card-text>
        </v-col>
      </v-row>
      <v-card-text class="pt-0">
        <loading-spinner v-if="loading"> </loading-spinner>
        <template v-else>
          <v-row>
            <v-col cols="12" sm="6" md="3" v-for="(item, i) in list" :key="i">
              <usage-overall-card :item="item"></usage-overall-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="6" v-for="(item, i) in trends" :key="i">
              <usage-trend-card :item="item"></usage-trend-card>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import UsageOverallCard from "@/components/reporting/UsageOverallCard";
import UsageTrendCard from "@/components/reporting/UsageTrendCard";
import TimeframeSelect from "@/components/reporting/TimeframeSelect";
export default {
  name: "UsageReport",
  props: { filter: { type: Object } },
  components: { UsageOverallCard, UsageTrendCard, TimeframeSelect },
  data: () => ({
    loading: false
  }),
  watch: {},
  computed: {
    ...mapGetters({ list: "reporting/usage", trends: "reporting/usage_trends" })
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      Promise.all([
        this.$store.dispatch("reporting/getUsage", this.filter),
        this.$store.dispatch("reporting/getUsageTrends", this.filter)
      ])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading report."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
